/**
* @file 运营中心-平台管理
* */
<template>
  <div id="settingFrame">
    <el-tabs type="card" v-model="currentTab">
      <el-tab-pane v-for="item in tabs" :key="item.name" :name="item.name">
        <template slot="label">
          <i v-if="item.icon" :class="item.icon" style="margin-right: 4px"></i>{{ item.label }}
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="content">
      <component :is="currentTab"></component>
    </div>
  </div>
</template>

<script>
import behaviorConfig from './behaviorConfig.vue'
import regionConfig from './regionConfig.vue'
import riskConfig from './riskConfig.vue'
export default {
  name: "settingFrame",
  components: {
    behaviorConfig,
    regionConfig,
    riskConfig
  },

  data() {
    return {
      // tabs列表
      tabs: [
        {label: "行为风控", name: "behaviorConfig", icon: 'el-icon-warning'},
        {label: "区域规则", name: "regionConfig", icon: 'el-icon-location'},
        {label: "切单风控", name: "riskConfig", icon: 'el-icon-s-tools'}
      ],
      currentTab: "behaviorConfig",
    };
  },
  watch: {
  },
  async created() {
    this.mixinOrganizations();
  },
};
</script>

<style lang="less">
#settingFrame {
  height: 100%;

  .content {
    height: calc(100% - 40px);

    & > div {
      height: 100%;
    }
  }
}
</style>
